import React, { useEffect, useState } from 'react';
import useProjects from '../../hooks/useProjects';
import Project from '../Project';

const ProjectSection = () => {
    const { projects, setProjects } = useProjects()
    return (
        <div id='projects'>
            <div className="container">
                <div className='styled__heading gradient__animation' style={{ display: "flex", alignItems: "center" }}>
                    <h1 className='primary__heading' style={{ fontSize: "25px" }}>━━  Projects</h1>
                </div>
                <h1 className='primary__heading accent__heading primary__heading__gap' style={{ color: "gray", marginBottom: "3rem", lineHeight: "58px" }}>Some things
                    <br />I've worked on</h1>
                <div className="projects__container">
                    {
                        projects.map(project => <Project project={project}></Project>)
                    }
                </div>
            </div>
        </div >
    );
};

export default ProjectSection;